export default __webpack_public_path__ + "static/media/lab-error-forbidden.80e2225e.svg";